import React from 'react';
import { get } from 'lodash'

import FirstTitle from "../../../shared/items/static/firstTitle"
import Paragraph from "../../../shared/items/static/paragraph"
import { sexData } from "./../sex/static.sexData"
import locales from "./../../../content.json"
import styles from "./successResultBlock.module.scss"

const contentData = {
  male: {
    image: "./img/man_result.png",
    name: locales[window.userLang].short_review_name_1,
    weight: "+4.7 " + locales[window.userLang].kg_value,
    comment: locales[window.userLang].short_review_content_1,
  },
  female: {
    image: "./img/girl_result.png",
    name: locales[window.userLang].short_review_name_2,
    weight: "-7.3 " + locales[window.userLang].kg_value,
    comment: locales[window.userLang].short_review_content_2,
  },
  other: {
    image: "./img/girl_result.png",
    name: locales[window.userLang].short_review_name_2,
    weight: "-7.3 " + locales[window.userLang].kg_value,
    comment: locales[window.userLang].short_review_content_2,
  }
}

const getContentData = (sex) => {
  switch (sex) {
    case sexData.male.value:
      return contentData.male;
    case sexData.female.value:
      return contentData.female;
    default:
      return contentData.other;
  }
}

const SuccessResultBlock = props => {
  const { data } = props
  const content = getContentData(get(data, ["sex", "value"], sexData.female.value))

  return (
    <div className={styles.successResult}>
      <FirstTitle>{locales[window.userLang].success_story}</FirstTitle>

      <div className={styles.successItem}>
        <div className={styles.successResultImages} style={{ backgroundImage: `url(${content.image})` }}></div>
        <div className={styles.aboutSuccess}>
          <span className={styles.name}>{content.name}</span>
          <span className={styles.weight}>{content.weight}</span>
        </div>
        <div className={styles.container_Comment}>
          <Paragraph>{content.comment}</Paragraph>
        </div>
      </div>
    </div>
  )
}

export default SuccessResultBlock;